/*
 * @Author: your name
 * @Date: 2019-06-17 13:52:03
 * @LastEditTime: 2020-02-26 15:41:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /d:\project\2019\07-website\02-code\webSiteHtml-onlineMap\source\src\components\onlineMap\model\POISearch.js
 */
import { KeyWordSearchServiceFactory } from "../../../utility/tdtService/Query/Service/KeyWordSearchServiceFactory.js";
import { SearchType } from "../../../utility/tdtService/Query/Model/SearchType.js";
import { CustomArray } from "../../../utility/common/CustomArray.js";
import { GuidUtility } from "../../../utility/common/GuidUtility.js";
import { GeometryExtentUtility } from "../../../utility/common/GeometryExtentUtility.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs.js";
import { SystemConfig } from "../../../config/SystemConfig.js";



/**
 * poi搜索结果项
 */
export class POIResultItem {
	
	constructor() {
		this.id = null;
		this.sn = -1;
		this.name = null;
		this.gbCode=null;
		
		this.x = null;
		this.y = null;
		//地址
		this.address = null;
		//手机
		this.phone = null;
		//备注
		this.remark=null;
		this.poiType = null;
		this.image = null;
		this.unfocusImage = null;
		this.focusImage = null;
		//选中状态
		this.focusStatus = false;
		this.crsCode = "EPSG:4326";


	}

	getJsonString()
    {   
        let jsonString = JSON.stringify(this);

        return jsonString;
    }


	static fromNationalTDTCommonJson(jsonObject) {
		let poiItem = null;
		if (!jsonObject) return poiItem;
		poiItem = new POIResultItem();
		poiItem.name = jsonObject.name;
		poiItem.address = jsonObject.address;
		poiItem.phone = jsonObject.phone;
		poiItem.id = GuidUtility.getGuid();

		if (jsonObject.lonlat) {
			let lonlatArray = jsonObject.lonlat.split(" ");
			if (lonlatArray.length == 2) {
				poiItem.x = parseFloat(lonlatArray[0]);
				poiItem.y = parseFloat(lonlatArray[1]);
			}
		}

		return poiItem;
	}

	static fromNationalTDTCommonSuggestJson(jsonObject) {
		let poiItem = null;
		if (!jsonObject) return poiItem;
		poiItem = new POIResultItem();
		poiItem.id = GuidUtility.getGuid();
		poiItem.name = jsonObject.name;
		poiItem.gbCode=jsonObject.gbCode;
		poiItem.address = jsonObject.address;
		return poiItem;
	}

	static fromJson(jsonObject)
	{	
		let poiItem=null;
		if(!jsonObject)return poiItem;
		poiItem=new POIResultItem();
		
		poiItem.id = jsonObject.id;
		poiItem.sn = jsonObject.sn;
		poiItem.name = jsonObject.name;
		poiItem.x = jsonObject.x;
		poiItem.y = jsonObject.y;
		//地址
		poiItem.address = jsonObject.address;
		//手机
		poiItem.phone = jsonObject.phone;
		//备注
		poiItem.remark=jsonObject.remark;
		poiItem.poiType = jsonObject.poiType;
		poiItem.image = jsonObject.image;
		poiItem.unfocusImage = jsonObject.unfocusImage;
		poiItem.focusImage = jsonObject.focusImage;
		//选中状态
		poiItem.focusStatus = jsonObject.focusStatus;
		poiItem.crsCode = jsonObject.crsCode;

		return poiItem;
	}

	static fromAddressInfo(addressInfo)
	{	
		let resultItem=new POIResultItem();
		
		resultItem.id = GuidUtility.getGuid();
		resultItem.sn = GuidUtility.getGuid();
		resultItem.name = addressInfo.poi;
		resultItem.x = addressInfo.lon;
		resultItem.y = addressInfo.lat;
		//地址
		resultItem.address = addressInfo.formattedAddress;
		//手机
		resultItem.phone = null;
		//备注
		resultItem.remark=null;
		
		return resultItem;
	}



}

/**
 * poi搜索结果项集合
 */
export class POIResultItems extends CustomArray {

	constructor() {
		super();


		this.count = -1;
	}


	/**
		 * 搜索
		 * @param {*筛选条件} filter 
		 * @param {*} succeedCallback 
		 * @param {*} errorCallback 
		 */
	static search(filter, succeedCallback, errorCallback) {

		if (!filter || !filter.filterType) return;

		if (filter.filterType === POISearchFilterType.national_common
			|| filter.filterType === POISearchFilterType.national_common_suggest
			|| filter.filterType === POISearchFilterType.national_purepoi
			|| filter.filterType===POISearchFilterType.national_common_center) {
			let tdtService = null;
			if (filter.filterType === POISearchFilterType.national_common_suggest) {
				tdtService = KeyWordSearchServiceFactory.GenerateKeyWordSearchService(SearchType.CommonSuggest);
			}
			else if (filter.filterType === POISearchFilterType.national_common) {
				tdtService = KeyWordSearchServiceFactory.GenerateKeyWordSearchService(SearchType.Common);
			}
			else if (filter.filterType === POISearchFilterType.national_purepoi) {
				tdtService = KeyWordSearchServiceFactory.GenerateKeyWordSearchService(SearchType.PurePOI);
			}
			else if(filter.filterType===POISearchFilterType.national_common_center)
			{
				tdtService = KeyWordSearchServiceFactory.GenerateKeyWordSearchService(SearchType.CenterPoint);
			}
			
			tdtService.tdtURL=ServiceUrlConfig.tdt_service_query_url;
			tdtService.centerPointX = filter.centerPointX;
			tdtService.centerPointY = filter.centerPointY;
			tdtService.radiusDistance=filter.radiusDistance;
			tdtService.start = filter.startIndex;
			tdtService.count = filter.count;
			tdtService.keyWord = filter.keyWord;
			tdtService.maxLat = filter.maxLat;
			tdtService.maxLon = filter.maxLon;
			tdtService.minLat = filter.minLat;
			tdtService.minLon = filter.minLon;
			tdtService.token = filter.token;
			tdtService.level = filter.level;
			if(filter.specifyAdminCode)
			{
				tdtService.specifyAdminCode=filter.specifyAdminCode;
			}
			
			tdtService.Query(function (jsons) {

				let poiItems = new POIResultItems();

				if (jsons) {

					if (jsons.resultType == 1) {
						//json对象转换
						poiItems = POIResultItems.fromNationalTDTCommonJson(jsons);
						succeedCallback(poiItems);
					}
					else if (jsons.resultType == 4) {
						poiItems = POIResultItems.fromNationalTDTCommonSuggestJson(jsons);
						succeedCallback(poiItems);
					}
					else if(jsons.resultType==2)
					{	
						
						let filterCopy= filter.copy();
						//为避免出现递归死循环的情况，只出现一次
						if(filterCopy.specifyAdminCode)
						{
							succeedCallback(poiItems);
						}
						else
						{	
							//如果返回值是统计信息，设置为甘肃，减少返回为统计信息的次数
							filterCopy.specifyAdminCode="156620000";
							POIResultItems.search(filterCopy,function(poiItems){
								succeedCallback(poiItems);
							},function(error){
								
								errorCallback(error);
							});
						}
					}
					else
					{
						succeedCallback(poiItems);
					}
				}
				else
				{	
					succeedCallback(poiItems);
				}

				

				
			}, function (error) {
				errorCallback(error);
			});
		}
	}


	static fromNationalTDTCommonJson(jsons) {
		let pois = new POIResultItems();
		if (!jsons || !jsons.pois) return pois;
		//poi总数
		pois.count = parseInt(jsons.count);

		if (jsons.pois.objects) {
			let tempPoiItem = null;
			for (let tempJsonIndex in jsons.pois.objects) {
				tempPoiItem = POIResultItem.fromNationalTDTCommonJson(jsons.pois.objects[tempJsonIndex]);
				if (tempPoiItem) {
					tempPoiItem.sn = tempJsonIndex;
					pois.push(tempPoiItem);
				}
			}
		}

		return pois;
	}

	static fromNationalTDTCommonSuggestJson(jsons) {
		let pois = new POIResultItems();
		if (!jsons || !jsons.suggests) return pois;
		//poi总数
		pois.count = parseInt(jsons.count);

		if (jsons.suggests.objects) {
			let tempPoiItem = null;
			for (let tempJsonIndex in jsons.suggests.objects) {
				tempPoiItem = POIResultItem.fromNationalTDTCommonSuggestJson(jsons.suggests.objects[tempJsonIndex]);
				if (tempPoiItem) {
					tempPoiItem.sn = tempJsonIndex;
					pois.push(tempPoiItem);
				}
			}
		}

		return pois;
	}

	static getPOICoordinates(poiArray) {
		let coordinates = new Array();

		if (!poiArray || poiArray.length === 0) return coordinates;

		let tempPoi = null;
		let tempCoordinate = null;
		for (let tempIndex = 0; tempIndex < poiArray.length; tempIndex++) {
			tempPoi = poiArray[tempIndex];
			tempCoordinate = new Array();
			tempCoordinate.push(tempPoi.x);
			tempCoordinate.push(tempPoi.y);
			coordinates.push(tempCoordinate);
		}

		return coordinates;
	}

}

/**
 * poi搜索筛选条件
 */
export class POISearchFilter {
	constructor() {
        /**
         * 筛选类型，默认为国家天地图普通搜索
         */
		this.filterType = POISearchFilterType.national_common;
		this.startIndex = 0;
		this.count = 10;
		this.keyWord = null;
		this.centerPointX = -1;
		this.centerPointY = -1;
		//默认查询缓冲距离是1000
		this.radiusDistance=5000;
		this.keyWord = null;
		this.level = -1;
		this.maxLat = -1;
		this.maxLon = -1;
		this.minLat = -1;
		this.minLon = -1;
		//默认为甘肃省
		this.specifyAdminCode=null;
		this.token =SystemConfig.token;
	}

	/**
	 * 
	 */
	copy() {
		let filterCopy = new POISearchFilter();
		filterCopy.filterType = this.filterType;
		filterCopy.startIndex = this.startIndex;
		filterCopy.count = this.count;
		filterCopy.keyWord = this.keyWord;
		filterCopy.centerPointX = this.centerPointX;
		filterCopy.centerPointY = this.centerPointY;
		filterCopy.radiusDistance=this.radiusDistance;
		filterCopy.keyWord = this.keyWord;
		filterCopy.level = this.level;
		filterCopy.maxLat = this.maxLat;
		filterCopy.maxLon = this.maxLon;
		filterCopy.minLat = this.minLat;
		filterCopy.minLon = this.minLon;
		filterCopy.specifyAdminCode=this.specifyAdminCode;
		filterCopy.token = this.token;

		return filterCopy;
	}

    /**
     * 从map地图中创建筛选条件
     * @param {*} currentMap 
     */
	static createFilterFromMap(currentMap) {
		let filter = new POISearchFilter();

		let boundsLatLng = currentMap.getBoundsLatLng();
		let mapExtent = [
			boundsLatLng.minX,
			boundsLatLng.minY,
			boundsLatLng.maxX,
			boundsLatLng.maxY
		];

		let extentIsGeo = GeometryExtentUtility.isGeoExtent(mapExtent);

		let geoBoundsLatLng = null;

		if (!extentIsGeo) {
			geoBoundsLatLng = ol.proj.transformExtent(
				mapExtent,
				"EPSG:3857",
				"EPSG:4326"
			);
		}
		else {
			geoBoundsLatLng = mapExtent;
		}


		filter.minLon = geoBoundsLatLng[0];
		filter.minLat = geoBoundsLatLng[1];
		filter.maxLon = geoBoundsLatLng[2];
		filter.maxLat = geoBoundsLatLng[3];

		filter.level = currentMap.getView().getZoom(); //获取当前地图的缩放级别
		//小于等于8级，国家天地图api查询不到数据，最小级别修改为9级
		if(filter.level<=8)
		{
			filter.level=9;
		}

		return filter;
	}


}

/**
 * 搜索筛选类型
 */
export const POISearchFilterType =
{
	national_common: "national_common",

	national_common_suggest: "national_common_suggest",

	national_purepoi: "national_purepoi",

	national_common_center:"national_centerPoint",
}

/**
 * poi周边搜索信息
 */
export class POISurroundInfo {
	constructor() {
		/**
		 * 周边搜索类型 POISurroundType类型
		 */
		this.surroundType = null;

		/**
		 * poi对象
		 */
		this.poi = null;

		/**
		 * 进行周边搜索poi的关键字
		 */
		this.surroundPOIFuzzyKey = null;
	}
}

/**
 * poi周边搜索类型
 */
export const POISurroundType =
{
	type_POI: "POI",

	type_route_startPOI: "route_startPOI",

	type_route_viaPOI: "route_viaPOI",

	type_route_endPOI: "route_endPOI"
}